<template>
	<div>
		<v-client-table
			v-model="footprints"
			:columns="fields"
			:options="options"
		>
			<router-link
				slot="edit"
				slot-scope="footprints"
				class="nav-item"
				:to="`/footprint/${footprints.row.id}`"
			>Edit</router-link>
		</v-client-table>
	</div>
</template>

<script>
export default {
	props: {
		footprints: {
			required: true,
			type: Array
		}
	},
	name: "FootprintTableList",
	data() {
		return {
			fields: [
				'code_key',
				'star_sign',
				'wos',
				'edit'
			],
			options: {
				resizableColumns: false,
				perPage: 10,
				perPageValues: [],
				filterable: false,
				highlightMatches: false,
				filterByColumn: false,
				skin: '',
				hiddenColumns: ['id'],
				headings: {
					delete: false,
					edit: false
				}
			}
		}
	}
}
</script>

<style scoped>

</style>